import { render, staticRenderFns } from "./ChallengeProgressComponent.vue?vue&type=template&id=706cbf99&"
import script from "./ChallengeProgressComponent.vue?vue&type=script&lang=ts&"
export * from "./ChallengeProgressComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ChallengeProgressComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports